import * as actionTypes from "./actions";

export const balanceInitialState = {
    balance: 0,
};

const balanceReducer = (state = balanceInitialState, action) => {
    switch (action.type) {
        case actionTypes.SET_BALANCE:
            return {
                ...state,
                balance: action.balance,
            };
        default:
            return state;
    }
};

export default balanceReducer;
